import Vue from 'vue'
import App from './App.vue'
import router from './router'
import log from './log'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
import Reiwa from './components/Reiwa.vue'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faStickyNote, faInfoCircle, faWrench} from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons' 
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add([faCoffee, faStickyNote, faInfoCircle, faWrench])
library.add(fab);
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)

Vue.component('navigation', Navigation)
Vue.component('site-footer', Footer)
Vue.component('reiwa', Reiwa)

// Firebase
import firebase from 'firebase';
import 'firebase/functions';
import auth from './auth';

let config = {
  apiKey: 'AIzaSyDpXTeYLP90Es8YO0LoXX8CXIIWUm810FQ',
  authDomain: "new-era-a0b6c.firebaseapp.com",
  databaseURL: "https://new-era-a0b6c.firebaseio.com",
  projectId: 'new-era-a0b6c',
};

let db;
let functions;
if (!firebase.apps.length) {
  firebase.initializeApp(config);
  db = firebase.firestore();
  functions = firebase.functions();
}

Vue.prototype.$db = db;
Vue.prototype.$firebase = firebase;
Vue.prototype.$functions = functions;

// 認証関連処理の初期化
auth.init(Vue).then((user) => {
  let profile = {};
  // Vue.observable(profile);
  Vue.prototype.$profile = profile;
  if (user) {
    Vue.set(profile, 'user', user);
  }

  router.amazonAdCount = 0;

  router.beforeEach((to, from, next) => {
    // `to` と `from` は両方ともルートオブジェクト
    // eslint-disable-next-line 
    log.methods.log('onChange route to',router.amazonAdCount, to);
   
    for (let i=0; i< router.amazonAdCount+10; i++){
      let scriptDiv = document.getElementById('amzn_assoc_ad_div_adunit_' + i);
      if (scriptDiv != null){
        // eslint-disable-next-line 
        log.methods.log('remove amzn_assoc_ad_div_adunit_'+i, to.name);
        scriptDiv.remove();
      }  
    }
    router.amazonAdCount++;
    next();
  })
  
  Vue.config.productionTip = false

  Vue.mixin(log);
  global.rootVue = new Vue({
    router,    
    render: h => h(App)
  }).$mount('#app')  

});

global.rootVue = 'tmp'